<div class="grid-y top-bar text-center">
  <div class="cell" *ngIf="!isStudios">
    <app-svg-icon id="aquent-logo" class="aq-logo" name="aquent_white" (click)="openWebsite()"></app-svg-icon>
  <div class="cell" *ngIf="isStudios">
    <app-svg-icon id="studios-logo" class="studios-logo" name="studios_white"></app-svg-icon>
  </div>
</div>
